import { Link } from 'react-router';
import { useUnreadNotifications } from '../../hooks/queries';
import { useT } from '../../i18n';

/** Bell with the number of unread in-app notifications. */
export function NotificationBell() {
  const unread = useUnreadNotifications().data?.unread ?? 0;
  const t = useT();
  return (
    <Link
      to="/notifications"
      className="relative grid size-11 shrink-0 place-items-center rounded-full border border-ink-700 bg-ink-850 text-ink-200"
      aria-label={unread ? t('Notifications, {n} new', { n: unread }) : t('Notifications')}
      data-testid="notification-bell"
    >
      <svg className="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 9a6 6 0 1 1 12 0c0 4.5 1.5 6.5 2.5 7.5h-17C4.5 15.5 6 13.5 6 9z" />
        <path d="M10 19.5a2 2 0 0 0 4 0" />
      </svg>
      {unread > 0 ? (
        <span
          className="absolute -right-1 -top-1 grid h-5 min-w-5 place-items-center rounded-full bg-enemy px-1 text-[11px] font-bold leading-none text-white ring-2 ring-ink-900"
          data-testid="notification-count"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      ) : null}
    </Link>
  );
}
